/* eslint-disable */
import request from './helpers'

export function getMenuList () {
    return request({
        url: '/backend/system/menu/list',
        method: 'get'
    })
}

export function getAllMenuList () {
    return request({
        url: '/backend/developer/menu/listAll',
        method: 'get'
    })
}

export function deleteMenu (menuId) {
    return request({
        url: '/backend/developer/menu/delete',
        method: 'delete',
        params: {
            menuId
        }
    })
}

export function saveMenu (data) {
    return request({
        url: '/backend/developer/menu/save',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateMenu (data) {
    return request({
        url: '/backend/developer/menu/update',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function setDefaultDisplay (data) {
    return request({
        url: '/backend/developer/menu/setDefaultDisplay',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function getPermission (menuFullPath) {
    return request({
        url: '/backend/system/function/listByPermission',
        method: 'get',
        params: {
            menuFullPath
        }
    })
}
